// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"b48e57ed","512":"d10e52b9","818":"9c9330a6"}[chunkId] + ".chunk.css";
};